<template>
	<div id="Contact">
		<Back />

		<section class="hero is-black is-small">
			<div class="hero-body">
				<div class="container has-text-centered">
					<p class="title has-text-white">Contactez-nous</p>
					<p class="subtitle has-text-white">Les devis sont gratuits</p>
				</div>
			</div>
		</section>
		<section class="section">
			<div class="container">
				<p class="subtitle has-text-centered">
					<span class="icon mdi mdi-cube-send is-large mdi-36px" />
					<br />Veuillez remplir de formulaire de contact ci-dessous
				</p>
				<br />
				<div class="columns">
					<div class="column">
						<div class="field">
							<p class="control has-icons-left has-icons-right">
								<input
									class="input"
									v-model="payload.first_name"
									type="text"
									name="Prénom"
									placeholder="Votre prénom"
									required
								/>
								<span class="icon is-small is-left">
									<span class="mdi mdi-account" />
								</span>
								<span class="icon is-small is-right">
									<b>*</b>
								</span>
							</p>
							<br />
							<p class="control has-icons-left has-icons-right">
								<input
									class="input"
									v-model="payload.last_name"
									name="Nom"
									type="text"
									placeholder="Votre nom"
									required
								/>
								<span class="icon is-small is-left">
									<span class="mdi mdi-account" />
								</span>
								<span class="icon is-small is-right">
									<b>*</b>
								</span>
							</p>
						</div>
					</div>
					<div class="column">
						<p class="control has-icons-left has-icons-right">
							<input
								class="input"
								v-model="payload.email"
								name="Email"
								type="email"
								placeholder="Votre email"
								required
							/>
							<span class="icon is-small is-left">
								<span class="mdi mdi-email" />
							</span>
							<span class="icon is-small is-right">
								<b>*</b>
							</span>
						</p>
						<br />
						<p class="control has-icons-left has-icons-right">
							<input
								class="input"
								v-model="payload.phone"
								name="Téléphone"
								type="text"
								placeholder="Votre numéro de téléphone"
								required
							/>
							<span class="icon is-small is-left">
								<span class="mdi mdi-phone" />
							</span>
						</p>
					</div>
				</div>
				<p class="control has-icons-left has-icons-right">
					<input
						class="input"
						v-model="payload.address"
						name="Adresse postale"
						type="text"
						placeholder="Votre adresse postale complète (numéro, rue, code postal, ville)"
						required
					/>
					<span class="icon is-small is-left">
						<span class="mdi mdi-map-marker" />
					</span>
					<span class="icon is-small is-right">
						<b>*</b>
					</span>
				</p>
				<br />
				<p class="control has-icons-left has-icons-right">
					<textarea
						class="input"
						v-model="payload.message"
						name="Message"
						type="text"
						placeholder="Votre demande"
						required
					/>
					<span class="icon is-small is-left">
						<span class="mdi mdi-message" />
					</span>
					<span class="icon is-small is-right">
						<b>*</b>
					</span>
				</p>
				<br />
				<p class="content has-text-centered">
					<br />
					<button @click="submit" class="button is-warning">Envoyer le formulaire</button>

					<br />
					<br />
					<i>
						Vous avez une réclamation ou une question ? Contactez-nous par mail :
						<b>
							<a href="mailto:contact@happychauffe.fr">contact@happychauffe.fr</a>
						</b>
					</i>
				</p>
			</div>
		</section>
	</div>
</template>

<script>
import Back from "@/components/Back";
import Axios from "axios";

export default {
	name: "Contact",
	components: {
		Back,
	},
	data: () => ({
		payload: {
			first_name: "",
			last_name: "",
			phone: "",
			email: "",
			address: "",
			message: "",
		},
	}),
	methods: {
		async submit() {
			try {
				await Axios.put("https://invoicekit.herokuapp.com/messages", {
					teamID: "52BCC9A4-B4BA-4294-9908-4CA994A08C44",
					...this.payload,
				});

				this.$router.push("/merci");
			} catch (ex) {
				console.log(ex);

				alert(
					"Impossible de soumettre le formulaire. Avez-vous bien tout remplis?"
				);
			}
		},
	},
};
</script>

<style scoped>
textarea {
	min-height: 100px;
	min-width: 100%;
	resize: vertical;
}
</style>